import { useState } from 'react';

export default function SubscribeCta() {
  const [done, setDone] = useState(false);

  const handle = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setDone(true);
  };

  return (
    <section className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="relative overflow-hidden rounded-lg border border-background-200 bg-foreground-950 px-6 py-10 md:px-12 md:py-14">
          <span className="pointer-events-none absolute -right-8 -top-10 font-display text-[160px] font-black leading-none text-background-50/5 select-none">NEWS</span>
          <span className="pointer-events-none absolute -bottom-12 left-1/3 h-40 w-40 rounded-full bg-primary-500/10 blur-2xl"></span>

          <div className="relative flex flex-col items-start justify-between gap-8 md:flex-row md:items-center">
            <div className="max-w-md">
              <span className="inline-flex items-center gap-2 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-foreground-950 whitespace-nowrap">
                <i className="ri-mail-send-line text-xs"></i>
                每日速递
              </span>
              <h2 className="mt-4 font-display text-2xl font-black leading-snug text-background-50 md:text-3xl">
                把今天的瓜，<br className="hidden md:block" />
                按时送到你面前
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-background-50/70">
                留下一封邮箱即可订阅本站每日速递，汇总、合集、盘点一次收齐。
              </p>
            </div>

            <form onSubmit={handle} className="w-full max-w-md">
              {done ? (
                <div className="flex items-center gap-3 rounded-md border border-background-50/15 bg-background-50/10 px-5 py-4 text-sm text-background-50">
                  <i className="ri-checkbox-circle-line text-xl text-accent-400"></i>
                  已加入每日速递队列（演示环境，不实际收集）
                </div>
              ) : (
                <div className="flex flex-col gap-3 sm:flex-row">
                  <input
                    type="email"
                    name="email"
                    required
                    placeholder="输入你的邮箱地址"
                    autoComplete="off"
                    className="w-full rounded-md border border-background-50/20 bg-background-50/10 px-4 py-3 text-sm text-background-50 placeholder:text-background-50/40 outline-none focus:border-accent-400 focus:ring-2 focus:ring-accent-500/30 transition"
                  />
                  <button
                    type="submit"
                    className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600 cursor-pointer"
                  >
                    立即订阅
                    <i className="ri-send-plane-line"></i>
                  </button>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}